import _ from 'lodash'
import type {ComponentFeature, ComponentFeatures, Namespace} from '@wix/document-services-types'
import {specialComponentFeatures} from './constants/constants'

const buildComponentFeatures = (componentDataQueriesMap: Record<string, string>): ComponentFeatures =>
    _(componentDataQueriesMap)
        .mapValues((query: string, namespace: Namespace) => ({
            query,
            namespace,
            alias: namespace
        }))
        .mapKeys(({alias}: ComponentFeature) => alias)
        .assign(specialComponentFeatures)
        .value()

export const getComponentFeatures = (componentDataQueriesMap: Record<string, string>): ComponentFeatures => {
    // TODO: DM-11989
    const {variants, breakpointVariants, ...rest} = buildComponentFeatures(componentDataQueriesMap)
    return {variants, breakpointVariants, ...rest}
}
